/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEtcResponse
 */
export interface UserEtcResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserEtcResponse
     */
    perimeter: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserEtcResponse
     */
    perimeterNames: Array<string> | null;
}

export function UserEtcResponseFromJSON(json: any): UserEtcResponse {
    return UserEtcResponseFromJSONTyped(json, false);
}

export function UserEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'perimeter': json['perimeter'],
        'perimeterNames': json['perimeterNames'],
    };
}

export function UserEtcResponseToJSON(value?: UserEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'perimeter': value.perimeter,
        'perimeterNames': value.perimeterNames,
    };
}

